// extracted by mini-css-extract-plugin
export default {"search-filter__wrapper":"SearchAndFilter_search-filter__wrapper__DQ3A0","search-filter__search":"SearchAndFilter_search-filter__search__Pb7fC"};